<template>
  <div id="app">
    <!-- <NavBar></NavBar> -->
    <!-- This map needs to be loaded in order to initialize the google object. this object is needed for the autocomplete-->
    <!-- <GmapMap :center="{ lat: 10, lng: 10 }" style="display:none"></GmapMap> -->
    <ProductOverviewPage v-if="showOverViewPage"></ProductOverviewPage>
    <ProductPage v-else></ProductPage>
  </div>
</template>

<script>
import ProductOverviewPage from "../src/views/ProductOverviewPage";
import ProductPage from "../src/views/ProductPage";
export default {
  name: "App",
  components: {
    ProductOverviewPage,
    ProductPage,
  },
  computed: {
    showOverViewPage: function() {
      //moet de content ophalen op basis van culture
      if (this.$store.state.miscData.miscDataReady) {
        var pathName = window.location.pathname;
        var OverviewPageURL = this.$store.state.miscData.miscData.OverviewPageURL;
        var projectUrls = this.$store.state.miscData.miscData.ProjectUrls;
        
        var pathNameContainsProjectUrl;
        for (let index = 0; index < projectUrls.length; index++) {
          let projectUrl = projectUrls[index];
          projectUrl = projectUrl.slice(0,-1)// remove trailing "/" because it might be missing and is not mandatory in the pathname;
          if (pathName.includes(projectUrl)) {
            pathNameContainsProjectUrl = true;
            break;
          } else {
            pathNameContainsProjectUrl = false;
          }
        }

        if(pathNameContainsProjectUrl) {
          return false;
        } else {
          return true;
        }
      }
    },
  },
  methods: {
    warn: function(message, event) {
      // now we have access to the native event
      if (event) {
        event.preventDefault();
      }
      alert(message);
      debugger;
      console.log("lmao");
    },
  },
  beforeCreate() {
    var URL = window.location.pathname;
    var arr = URL.split("/");
    var language = arr[1];
    if (language.length > 2) {
      // language is not a language but the projects url so the default language must be used.
      language = ""; // ""
    }

    this.$store.dispatch("getProducts", language);
    this.$store.dispatch("getMiscData", language);
  },
};
</script>

<style lang="scss">
b-img {
  display: block;
  width: 100%;
  height: auto;
}
.white {
  color: white;
}
#app {
  padding: 0px 0;
}
.column1 {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.row1 {
  display: flex;
  flex-direction: row;
  justify-content: start;
}
</style>
